<p-progressSpinner class="resy_spinner spinner_in_front" *ngIf="spinner"></p-progressSpinner>
<div class="panel_wrapper">
  <div class="reservation-details">
    <div class="d-flex flex-column" *ngIf="showVenueName">
      <span class="font-weight-800">{{'VENUE.VENUE_NAME' | translate}}:</span>
      <span class="ellipsis">{{venueName}}</span>
    </div>
    <div class="d-flex flex-column">
      <span class="font-weight-800">{{'RESERVATION.FULL_NAME' | translate}}:</span>
      <span class="ellipsis">{{reservationDetails.firstName}} {{reservationDetails.lastName}}</span>
    </div>
    <div class="d-flex flex-column">
      <span class="font-weight-800">{{'RESERVATION.EMAIL' | translate}}:</span>
      <span class="ellipsis">{{reservationDetails.email}}</span>
    </div>
    <div class="d-flex flex-column">
      <span class="font-weight-800">{{'RESERVATION.PHONE' | translate}}:</span>
      <span>{{reservationDetails.phone}}</span>
    </div>
    <div class="d-flex flex-column">
      <span class="font-weight-800">{{'RESERVATION.DATE' | translate}}:</span>
      <span>{{reservationDetails.reservationDateAndTime | date: 'dd.MM.yyyy'}}</span>
    </div>
    <div class="d-flex flex-column">
      <span class="font-weight-800">{{'RESERVATION.GUESTS' | translate}}:</span>
      <span>{{reservationDetails.numberOfGuests}}</span>
    </div>
    <div class="d-flex flex-column">
      <span class="font-weight-800">{{'RESERVATION.TIME' | translate}}:</span>
      <span>{{reservationDetails.reservationDateAndTime | date: 'hh:mm a'}}</span>
    </div>
    <div class="d-flex flex-column" *ngIf="reservationDetails.comment">
      <span class="font-weight-800">{{'RESERVATION.COMMENT' | translate}}:</span>
      <span class="details-comment">{{reservationDetails.comment}}</span>
    </div>
    <div class="d-flex flex-column" *ngIf="reservationDetails.status === reservationStatusEnum.Declined && reservationDetails.declinedComment">
      <span class="font-weight-800">{{'RESERVATION.DECLINE_COMMENT' | translate}}:</span>
      <span class="details-comment">{{reservationDetails.declinedComment}}</span>
    </div>
    <div class="d-flex flex-column" *ngIf="reservationDetails.status === reservationStatusEnum.Canceled && reservationDetails.canceledComment">
      <span class="font-weight-800">{{'RESERVATION.CANCEL_COMMENT' | translate}}:</span>
      <span class="details-comment">{{reservationDetails.canceledComment}}</span>
    </div>
    <div class="d-flex flex-column w-100 mt-2 justify-content-start" *ngIf="pastList">
      <button class="change-password-btn p-0" (click)="showMoreDetails = !showMoreDetails" style="width: 125px;">
        {{'RESERVATION.MORE_DETAILS' | translate}}
        <i class="pi pi-angle-down magenta-color ms-2"></i>
      </button>
      <div class="d-flex justify-content-between flex-column more-details" *ngIf="showMoreDetails">
        <div *ngIf="reservationDetails.hostName && reservationDetails.hostName !== ''">
          <span class="ellipsis">{{'RESERVATION.HOST_INFO' | translate}}: {{reservationDetails.hostName}}</span>
        </div>
        <div>
          <span>{{'RESERVATION.GUEST_ARRIVED' | translate}}: {{reservationDetails.seatDateTime | date: 'hh:mm a'}}</span>
        </div>
        <div>
          <span>{{'RESERVATION.GUEST_LEFT' | translate}}: {{reservationDetails.leaveDateTime | date: 'hh:mm a'}}</span>
        </div>
        <div class="d-flex flex-row justify-content-between">
          <div>
            <span>{{'RESERVATION.BILL_AMOUNT' | translate}}: ${{reservationDetails.amount}}</span>
          </div>
          <div>
            <span>{{'RESERVATION.BILL_TIP' | translate}}: ${{reservationDetails.tips}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex flex-row w-100 mt-2" *ngIf="reservationDetails.leaveDateTime == null">
    <button class="change-password-btn p-0"
            (click)="openDetailsPopup()">{{'RESERVATION.SEE_RESERVATIONS' | translate}}</button>
  </div>
  <div class="d-flex flex-row w-100 mt-2" *ngIf="reservationDetails.status === reservationStatusEnum.Pending && !reservationDetails.hasPriority">
    <button class="btn-group-text create_btn yellow_outline_btn w-100"
            (click)="addToPriorityList()">{{'RESERVATION.ADD_AS_PRIORITY' | translate}}
      <img class="ms-1 mb-1" src="assets/icons/star_bright_yellow_24px.svg" alt="star" style="width: 20px; height: 19px;">
    </button>
  </div>
  <div *ngIf="reservationDetails.status && reservationDetails.status == reservationStatusEnum.Pending"
       class="d-flex flex-row justify-content-between mt-3">
    <button class="btn-group-text create_btn w-100"
            (click)="approveOrDeclineReservation(true)">{{ 'RESERVATION.APPROVE' | translate}}</button>
    <button class="btn_without_color w-100 m-0"
            (click)="approveOrDeclineReservation(false)">{{ 'RESERVATION.DECLINE' | translate}}</button>
  </div>
</div>
